import type { Department } from '#shared/types';
import { Badge } from '#client/components/ui/Badge';
import { Card } from '#client/components/ui/Card';
import { DetailList } from '#client/components/ui/DetailList';
import { ResourceDetailPage } from '#client/components/ui/ResourceDetailPage';
import { formatDateTime } from '#client/lib/format';
import { RESOURCE } from '#client/lib/routes';

const PATH = RESOURCE.departments;

export function DepartmentDetailPage() {
  return (
    <ResourceDetailPage<Department>
      path={PATH}
      noun="department"
      editCapability="department.edit"
      deleteCapability="department.delete"
      title={(department) => department.name}
      subtitle={() => 'Department'}
      deleteLabel={(department) => department.name}
    >
      {(department) => (
        <Card>
          <DetailList
            items={[
              { label: 'Code', value: department.code, mono: true },
              { label: 'Sort order', value: String(department.sort_order) },
              {
                label: 'Status',
                value: department.is_active ? (
                  <Badge tone="success">Active</Badge>
                ) : (
                  <Badge tone="neutral">Inactive</Badge>
                ),
              },
              { label: 'Created', value: formatDateTime(department.created_at) },
              { label: 'Last updated', value: formatDateTime(department.updated_at) },
            ]}
          />
        </Card>
      )}
    </ResourceDetailPage>
  );
}
